module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 7);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = {
    alignCenter: !0,
    arrowClass: "scroll-menu-arrow",
    clickWhenDrag: !1,
    dragging: !0,
    data: [],
    firstPageOffset: 0,
    innerWrapperClass: "menu-wrapper--inner",
    itemClass: "menu-item-wrapper",
    itemClassActive: "active",
    hideArrows: !1,
    hideSingleArrow: !1,
    lastPageOffset: 0,
    menuItems: [],
    menuPos: 0,
    menuWidth: 0,
    menuClass: "horizontal-menu",
    selected: 0,
    translate: 0,
    transition: .4,
    wrapperClass: "menu-wrapper",
    wheel: !0,
    xPoint: 0
  },
      i = {
    alignCenter: r.alignCenter,
    arrowClass: r.arrowClass,
    innerWrapperClass: r.innerWrapperClass,
    itemClass: r.itemClass,
    itemClassActive: r.itemClassActive,
    hideArrows: r.hideArrows,
    hideSingleArrow: r.hideSingleArrow,
    clickWhenDrag: r.clickWhenDrag,
    data: r.data,
    dragging: r.dragging,
    selected: r.selected,
    transition: r.transition,
    translate: r.translate,
    menuClass: r.menuClass,
    wheel: r.wheel,
    wrapperClass: r.wrapperClass
  };
  t.defaultSetting = r, t.defaultProps = i, t.defaultMenuStyle = {
    display: "flex",
    alignItems: "center",
    userSelect: "none"
  }, t.defaultWrapperStyle = {
    overflow: "hidden",
    userSelect: "none"
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.notUndefOrNull = function (e) {
    return void 0 !== e && null !== e;
  }, t.getClientRect = function (e) {
    var t = e.getBoundingClientRect(),
        n = t.x,
        r = t.left;
    return {
      width: t.width,
      x: isNaN(n) ? +r : +n
    };
  }, t.testPassiveEventSupport = function () {
    var e = !1;

    try {
      var t = {
        get passive() {
          return e = !0, !1;
        }

      };
      window.addEventListener("testPassiveEventSupport", t, t), window.removeEventListener("testPassiveEventSupport", t, t);
    } catch (t) {
      e = !1;
    }

    return e;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  var r = n(2);

  function i() {}

  e.exports = function () {
    function e(e, t, n, i, a, s) {
      if (s !== r) {
        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw o.name = "Invariant Violation", o;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = i, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  e.exports = n(3)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.propTypes = t.ScrollMenu = t.InnerWrapper = t.innerStyle = t.ArrowWrapper = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      a = u(n(5)),
      s = u(n(4)),
      o = n(1),
      l = n(0);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function f(e, t) {
    var n = {};

    for (var r in e) {
      t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }

    return n;
  }

  function d(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function c(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function g(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var m = t.ArrowWrapper = function (e) {
    var t = e.className,
        n = e.onClick,
        r = e.children,
        i = e.isDisabled,
        s = t + " " + (e.hideArrows ? i ? t + "--disabled" : "" : "");
    return a.default.createElement("div", {
      className: s,
      onClick: n
    }, r);
  };

  m.propTypes = {
    className: s.default.string,
    onClick: s.default.func.isRequired,
    children: s.default.object.isRequired,
    isDisabled: s.default.bool,
    hideArrows: s.default.bool
  };

  var p = t.innerStyle = function (e) {
    var t = e.translate,
        n = e.dragging,
        r = e.mounted,
        i = e.transition;
    return {
      width: "9900px",
      transform: "translate3d(" + t + "px, 0px, 0px)",
      transition: "transform " + (n || !r ? "0" : i) + "s",
      whiteSpace: "nowrap",
      textAlign: "left",
      userSelect: "none"
    };
  },
      h = t.InnerWrapper = function (e) {
    function t(e) {
      d(this, t);
      var n = c(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.setRef = function (e, t) {
        var r = n.props.setRef;
        n.ref[e] = t, r(n.ref);
      }, n.ref = {}, n;
    }

    return g(t, a.default.Component), i(t, [{
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.data,
            r = t.translate,
            i = t.dragging,
            s = t.mounted,
            o = t.transition,
            l = t.selected,
            u = t.innerWrapperClass,
            f = t.itemClass,
            d = t.onClick,
            c = t.itemClassActive,
            g = function g(e, t) {
          return String(e) === String(t);
        },
            m = n.map(function (e) {
          return a.default.cloneElement(e, {
            selected: g(e.key, l)
          });
        });

        return a.default.createElement("div", {
          className: u,
          style: p({
            translate: r,
            dragging: i,
            mounted: s,
            transition: o
          }),
          ref: function ref(t) {
            return e.setRef("menuInner", t);
          }
        }, m.map(function (t, n) {
          return a.default.createElement("div", {
            ref: function ref(t) {
              return e.setRef("menuitem-" + n, t);
            },
            className: f + " " + (g(t.key, l) ? c : ""),
            key: "menuItem-" + t.key,
            style: {
              display: "inline-block"
            },
            onClick: function onClick() {
              return d(t.key);
            }
          }, t);
        }));
      }
    }]), t;
  }();

  h.propTypes = {
    data: s.default.arrayOf(s.default.object).isRequired,
    setRef: s.default.func.isRequired,
    onClick: s.default.func.isRequired,
    translate: s.default.number,
    dragging: s.default.bool,
    mounted: s.default.bool,
    transition: s.default.number,
    selected: s.default.oneOfType([s.default.string, s.default.number]),
    innerWrapperClass: s.default.string,
    itemClass: s.default.string,
    itemClassActive: s.default.string
  }, h.defaultProps = {
    data: [],
    translate: l.defaultSetting.translate,
    dragging: !0,
    mounted: !1,
    transition: l.defaultSetting.transition,
    selected: l.defaultSetting.selected
  };

  var v = t.ScrollMenu = function (e) {
    function t(e) {
      d(this, t);
      var n = c(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.state = {
        dragging: !1,
        xPoint: l.defaultSetting.xPoint,
        translate: n.props.translate,
        startDragTranslate: null,
        xDraggedDistance: null,
        leftArrowVisible: !0,
        rightArrowVisible: !0
      }, n.checkArrows = function () {
        var e = n.props.transition;
        clearTimeout(n.checkArrowTimer), n.checkArrowTimer = setTimeout(function () {
          return n.setSingleArrowVisibility();
        }, 1e3 * (e + .1));
      }, n.setRef = function (e) {
        n.ref = e;
      }, n.setWrapperRef = function (e) {
        n.ref.menuWrapper = e;
      }, n.checkSingleArrowVisibility = function (e) {
        var t = e.translate,
            r = void 0 === t ? n.state.translate : t,
            i = n.props.hideSingleArrow,
            a = !0,
            s = !0,
            o = n.menuItems;

        if (i && o) {
          var l = n.getVisibleItems({
            offset: r
          });
          a = !l.includes(o[0]), s = !l.includes(o.slice(-1)[0]);
        }

        return {
          leftArrowVisible: a,
          rightArrowVisible: s
        };
      }, n.setSingleArrowVisibility = function () {
        var e = n.state,
            t = e.leftArrowVisible,
            r = e.rightArrowVisible,
            i = n.checkSingleArrowVisibility({}),
            a = i.leftArrowVisible,
            s = i.rightArrowVisible;
        t === a && r === s || n.setState({
          leftArrowVisible: a,
          rightArrowVisible: s
        });
      }, n.onLoad = function () {
        n.mounted = !0, n.setInitial();
      }, n.setInitial = function () {
        var e = n.props,
            t = e.selected,
            r = e.data,
            i = n.state.translate;
        if (!r || !r.length) return !1;
        var a = n.getMenuItems(r.length),
            s = r.find(function (e) {
          return e.key === t;
        }),
            o = {
          menuItems: a,
          selected: s && -1 !== s ? s.key : l.defaultSetting.selected
        };

        for (var u in o) {
          n[u] = o[u];
        }

        var d = n.updateWidth({
          items: a,
          offset: 0,
          translate: 0
        }),
            c = (d.translate, f(d, ["translate"]));

        for (var g in c) {
          n[g] = c[g];
        }

        var m = n.getAlignItemsOffset(),
            p = "number" == typeof m && +m.toFixed(3),
            h = n.checkSingleArrowVisibility({
          translate: p
        }),
            v = h.leftArrowVisible,
            w = h.rightArrowVisible;
        "number" == typeof p && i !== p && n.setState({
          translate: p,
          leftArrowVisible: v,
          rightArrowVisible: w
        }, function () {
          return n.onUpdate({
            translate: p
          });
        });
      }, n.getMenuItems = function (e) {
        return Object.entries(n.ref).filter(function (e) {
          return e[0].includes("menuitem");
        }).slice(0, e).filter(Boolean);
      }, n.getItemsWidth = function (e) {
        var t = e.items,
            r = void 0 === t ? n.menuItems : t;
        return (r && r.items || r).map(function (e) {
          return e[1];
        }).filter(Boolean).reduce(function (e, t) {
          return e + (0, o.getClientRect)(t).width;
        }, 0);
      }, n.getWidth = function (e) {
        var t = e.items,
            r = window && window.innerWidth,
            i = (0, o.getClientRect)(n.ref.menuWrapper);
        return {
          wWidth: r,
          menuPos: i.x,
          menuWidth: i.width,
          allItemsWidth: n.getItemsWidth({
            items: t
          })
        };
      }, n.updateWidth = function (e) {
        var t = e.items,
            i = void 0 === t ? n.menuItems : t,
            a = f(e, ["items"]),
            s = n.props.alignCenter,
            o = n.getWidth({
          items: i
        });
        return r({}, o, s ? n.getPagesOffsets(r({
          items: i
        }, o, a)) : {});
      }, n.getPagesOffsets = function (e) {
        var t = e.items,
            r = void 0 === t ? n.menuItems : t,
            i = e.allItemsWidth,
            a = void 0 === i ? n.allItemsWidth : i,
            s = e.wWidth,
            o = void 0 === s ? n.wWidth : s,
            l = e.menuPos,
            u = void 0 === l ? n.menuPos : l,
            f = e.menuWidth,
            d = void 0 === f ? n.menuWidth : f,
            c = e.translate,
            g = void 0 === c ? n.state.translate : c,
            m = e.offset,
            p = void 0 === m ? n.state.translate : m,
            h = n.props.alignCenter,
            v = n.getVisibleItems({
          offset: p,
          items: r,
          wWidth: o,
          menuPos: u,
          menuWidth: d
        }),
            w = +n.getCenterOffset({
          items: v,
          menuWidth: d
        }).toFixed(3),
            b = n.getVisibleItems({
          items: r,
          offset: -a + d,
          wWidth: o,
          menuPos: u,
          menuWidth: d
        }),
            y = +n.getCenterOffset({
          items: b,
          menuWidth: d
        }).toFixed(3),
            C = h ? w : g;
        return n.firstPageOffset = w, n.lastPageOffset = y, {
          firstPageOffset: w,
          lastPageOffset: y,
          translate: +C.toFixed(3)
        };
      }, n.onItemClick = function (e) {
        var t = n.props,
            r = t.clickWhenDrag,
            i = t.onSelect;
        if (n.state.xDraggedDistance > 5 && !r) return !1;
        n.selected = e, i && i(e);
      }, n.getVisibleItems = function (e) {
        var t = e.items,
            r = void 0 === t ? n.menuItems : t,
            i = e.wWidth,
            a = void 0 === i ? n.wWidth : i,
            s = e.menuPos,
            l = void 0 === s ? n.menuPos : s,
            u = e.menuWidth,
            f = void 0 === u ? n.menuWidth : u,
            d = e.offset,
            c = void 0 === d ? n.state.translate : d,
            g = e.translate,
            m = void 0 === g ? n.state.translate : g;
        return (r.items || r).filter(function (e) {
          var t = (0, o.getClientRect)(e[1]).width,
              i = n.getItemInd(r, e),
              s = n.getOffsetToItem({
            itemId: i,
            menuItems: r,
            translate: m
          });
          return n.elemVisible({
            x: s,
            elWidth: t,
            wWidth: a,
            menuPos: l,
            menuWidth: f,
            offset: c
          });
        });
      }, n.elemVisible = function (e) {
        var t = e.x,
            r = e.offset,
            i = void 0 === r ? 0 : r,
            a = e.elWidth,
            s = e.wWidth,
            o = void 0 === s ? n.wWidth : s,
            l = e.menuPos,
            u = void 0 === l ? n.menuPos : l,
            f = e.menuWidth,
            d = void 0 === f ? n.menuWidth : f,
            c = t + i;
        return c >= u - 1 && c + a <= o - (o - (u + d)) + 1;
      }, n.getItemInd = function (e, t) {
        return e && t ? e.findIndex(function (e) {
          return e[0] === t[0];
        }) : 0;
      }, n.getNextItemInd = function (e, t) {
        var r = n.menuItems;

        if (e) {
          if (!t.length) return 0;
        } else if (!t.length) return r.length;

        var i = e ? n.getItemInd(r, t[0]) - 1 : n.getItemInd(r, t.slice(-1)[0]) + 1;
        return i < 0 ? 0 : i;
      }, n.getOffsetToItem = function (e) {
        var t = e.itemId,
            r = e.menuItems,
            i = void 0 === r ? n.menuItems : r,
            a = e.translate,
            s = void 0 === a ? n.state.translate : a;
        if (!i.length) return 0;
        var l = t >= i.length ? i.length - 1 : t;
        return +(0, o.getClientRect)(i[l][1]).x - s;
      }, n.getScrollRightOffset = function (e, t) {
        var r = n.props.alignCenter,
            i = n.menuPos,
            a = n.lastPageOffset,
            s = n.getNextItem(e && e.slice(-1)[0] ? e.slice(-1)[0][0] : t.slice(-1)[0][0]),
            o = t.findIndex(function (e) {
          return e[0] === s[0];
        }),
            l = n.getOffsetToItem({
          itemId: o,
          menuItems: t
        }) - i,
            u = n.getVisibleItems({
          items: t,
          offset: -l
        });
        if (u.includes(t.slice(-1)[0])) return r ? l + a : l;
        return r ? l - n.getCenterOffset({
          items: u
        }) : l;
      }, n.getScrollLeftOffset = function (e, t) {
        var r = n.props.alignCenter,
            i = n.menuPos,
            a = n.menuWidth,
            s = n.firstPageOffset,
            o = n.getPrevItem(e && e[0] ? e[0][0] : t[0][0]),
            l = t.findIndex(function (e) {
          return e[0] === o[0];
        }),
            u = n.getOffsetToItem({
          itemId: l,
          menuItems: t
        }) - i - (a - n.getItemsWidth({
          items: [o]
        })),
            f = n.getVisibleItems({
          items: t,
          offset: -u
        });
        if (f.includes(t[0])) return r ? -s : 0;
        return r ? u + n.getCenterOffset({
          items: f
        }) : u;
      }, n.getAlignItemsOffset = function () {
        var e = n.menuWidth,
            t = n.allItemsWidth,
            r = n.menuItems,
            i = n.firstPageOffset,
            a = n.lastPageOffset,
            s = n.props.alignCenter,
            o = n.state.translate;
        if (t < e) return n.handleArrowClick(!s);
        var u = n.getVisibleItems({
          offset: 0
        }) || [],
            f = u.includes(r[0]),
            d = u.includes(r.slice(-1)[0]);
        if (!f && !d) return +o.toFixed(3);
        if (f) return +(s ? i : l.defaultSetting.translate).toFixed(3);
        var c = t - e;
        return +(s ? -c - a : -c).toFixed(3);
      }, n.getNextItem = function (e) {
        var t = n.menuItems;
        return t[t.findIndex(function (t) {
          return t[0] === e;
        }) + 1] || t.slice(-1)[0];
      }, n.getPrevItem = function (e) {
        var t = n.menuItems;
        return t[t.findIndex(function (t) {
          return t[0] === e;
        }) - 1] || t[0];
      }, n.getOffset = function (e) {
        var t = n.menuItems,
            r = n.getVisibleItems({
          items: t
        });
        return e ? n.getScrollLeftOffset(r, t) : n.getScrollRightOffset(r, t);
      }, n.getCenterOffset = function (e) {
        var t = e.items,
            r = void 0 === t ? n.menuItems : t,
            i = e.menuWidth,
            a = void 0 === i ? n.menuWidth : i;
        return r.length ? +((a - n.getItemsWidth({
          items: r
        })) / 2).toFixed(3) : 0;
      }, n.handleWheel = function (e) {
        if (!n.props.wheel) return !1;
        e.deltaY < 0 ? n.handleArrowClick() : n.handleArrowClick(!1);
      }, n.handleArrowClickRight = function () {
        n.handleArrowClick(!1);
      }, n.handleArrowClick = function () {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            t = n.props.alignCenter,
            r = n.allItemsWidth,
            i = n.menuWidth,
            a = n.firstPageOffset,
            s = n.lastPageOffset,
            o = n.state.translate;
        if (!t && !e && i > r) return !1;
        var u = -n.getOffset(e);

        if (e && n.itBeforeStart(u) && (u = t ? a : l.defaultSetting.translate), !e && n.itAfterEnd(u)) {
          var f = r - i;
          u = t ? -f - s : -f;
        }

        var d = +u.toFixed(3);
        n.setState({
          translate: d,
          xPoint: l.defaultSetting.xPoint,
          startDragTranslate: null,
          xDraggedDistance: null
        }, function () {
          o !== d && n.onUpdate({});
        });
      }, n.itBeforeStart = function (e) {
        var t = n.props.alignCenter,
            r = n.firstPageOffset;
        return t ? e > r : e > l.defaultSetting.translate;
      }, n.itAfterEnd = function (e) {
        var t = n.props.alignCenter,
            r = n.menuWidth,
            i = n.allItemsWidth,
            a = n.lastPageOffset;
        return t ? e < l.defaultSetting.translate && Math.abs(e) > i - r + a : e < l.defaultSetting.translate && Math.abs(e) > i - r;
      }, n.getPoint = function (e) {
        return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
      }, n.handleDragStart = function (e) {
        if (e && 2 === e.buttons) return !1;
        if (!n.props.dragging) return !1;
        var t = n.state.translate;
        n.setState({
          dragging: !0,
          xPoint: 0,
          startDragTranslate: t,
          xDraggedDistance: 0
        });
      }, n.handleDrag = function (e) {
        var t = n.props.dragging,
            r = n.state,
            i = r.translate,
            a = r.dragging,
            s = r.xPoint,
            o = r.xDraggedDistance;
        if (!t || !a) return !1;
        var u = n.getPoint(e),
            f = s === l.defaultSetting.xPoint ? l.defaultSetting.xPoint : s - u,
            d = i - f;
        n.itBeforeStart(d) && (d -= Math.abs(f) / 2), n.itAfterEnd(d) && (d += Math.abs(f) / 2);
        var c = +d.toFixed(3);
        n.setState({
          xPoint: u,
          translate: c,
          xDraggedDistance: o + Math.abs(f)
        });
      }, n.handleDragStop = function (e) {
        var t = n.allItemsWidth,
            r = n.menuWidth,
            i = n.firstPageOffset,
            a = n.lastPageOffset,
            s = n.startDragTranslate,
            o = n.state,
            u = o.dragging,
            f = o.xPoint,
            d = void 0 === f ? n.getPoint(e) : f,
            c = o.translate,
            g = n.props,
            m = g.dragging,
            p = g.alignCenter;
        if (!m || !u) return !1;
        var h = c;

        if (n.itBeforeStart(c) && (h = p ? i : 0, d = l.defaultSetting.xPoint), n.itAfterEnd(c)) {
          var v = t - r;
          h = p ? -v - a : -v, d = l.defaultSetting.xPoint;
        }

        !p && r >= t && (h = 0, d = l.defaultSetting.xPoint), n.setState({
          dragging: !1,
          xPoint: d,
          translate: +h.toFixed(3)
        }, function () {
          s !== h && n.onUpdate({});
        });
      }, n.isArrowsVisible = function () {
        var e = n.allItemsWidth,
            t = n.menuWidth,
            r = n.props.hideArrows;
        return !Boolean(r && e <= t);
      }, n.onUpdate = function (e) {
        var t = e.translate,
            r = void 0 === t ? n.state.translate : t,
            i = n.props.onUpdate;
        i && i({
          translate: r
        });
      }, n.ref = {}, n.mounted = !1, n.needUpdate = !1, n.allItemsWidth = 0, n.menuPos = 0, n.menuWidth = 0, n.wWidth = 0, n.firstPageOffset = 0, n.lastPageOffset = 0, n.checkArrowTimer = function () {
        return null;
      }, n;
    }

    return g(t, a.default.Component), i(t, [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        this.setInitial();
        var t = (0, o.testPassiveEventSupport)(),
            n = !t || {
          passive: !0,
          capture: !0
        },
            r = !!t && {
          passive: !0,
          capture: !1
        };
        window.addEventListener("load", this.onLoad, r), window.addEventListener("resize", this.setInitial, r), document.addEventListener("mousemove", this.handleDrag, n), document.addEventListener("mouseup", this.handleDragStop, n), setTimeout(function () {
          return e.onLoad();
        }, 0);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e, t) {
        var n = this.state,
            r = n.translate,
            i = n.dragging,
            a = n.leftArrowVisible,
            s = n.rightArrowVisible,
            l = t.translate,
            u = t.dragging,
            f = t.leftArrowVisible,
            d = t.rightArrowVisible,
            c = this.props,
            g = c.translate,
            m = c.selected,
            p = e.translate,
            h = e.selected,
            v = (0, o.notUndefOrNull)(p) && g !== p,
            w = (0, o.notUndefOrNull)(h) && m !== h,
            b = v || w,
            y = a !== f,
            C = s !== d,
            I = !1;
        return this.props.data === e.data && this.props.data.length === e.data.length || (I = !0, this.needUpdate = !0), b && (w && (this.selected = h), isNaN(p) || !v || I || this.setState({
          translate: +p.toFixed(3)
        })), I || r !== l || i !== u || b || y || C;
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.needUpdate && (this.needUpdate = !1, this.onLoad()), this.props.hideSingleArrow && (this.setSingleArrowVisibility(), this.checkArrows());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.setInitial), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragStop);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.arrowClass,
            n = e.arrowLeft,
            i = e.arrowRight,
            s = e.data,
            o = e.innerWrapperClass,
            u = e.itemClass,
            f = e.itemClassActive,
            d = e.hideArrows,
            c = e.menuStyle,
            g = e.menuClass,
            p = e.transition,
            v = e.wrapperClass,
            w = e.wrapperStyle,
            b = this.state,
            y = b.translate,
            C = b.dragging,
            I = b.leftArrowVisible,
            S = b.rightArrowVisible,
            P = this.selected,
            W = this.mounted;
        if (!s || !s.length) return null;
        var O = !W || this.isArrowsVisible(),
            A = r({}, l.defaultMenuStyle, c),
            x = r({}, l.defaultWrapperStyle, w);
        return a.default.createElement("div", {
          className: g,
          style: A,
          onWheel: this.handleWheel
        }, n && a.default.createElement(m, {
          className: t,
          isDisabled: !O || !I,
          hideArrows: d,
          onClick: this.handleArrowClick
        }, n), a.default.createElement("div", {
          className: v,
          style: x,
          ref: this.setWrapperRef,
          onMouseDown: this.handleDragStart,
          onTouchStart: this.handleDragStart,
          onTouchEnd: this.handleDragStop,
          onMouseMove: this.handleDrag,
          onTouchMove: this.handleDrag
        }, a.default.createElement(h, {
          data: s,
          translate: y,
          dragging: C,
          mounted: W,
          transition: p,
          selected: P,
          setRef: this.setRef,
          onClick: this.onItemClick,
          innerWrapperClass: o,
          itemClass: u,
          itemClassActive: f
        })), i && a.default.createElement(m, {
          className: t,
          isDisabled: !O || !S,
          hideArrows: d,
          onClick: this.handleArrowClickRight
        }, i));
      }
    }]), t;
  }(),
      w = t.propTypes = {
    alignCenter: s.default.bool,
    arrowClass: s.default.string,
    arrowLeft: s.default.object,
    arrowRight: s.default.object,
    clickWhenDrag: s.default.bool,
    data: s.default.array.isRequired,
    dragging: s.default.bool,
    innerWrapperClass: s.default.string,
    itemClass: s.default.string,
    itemClassActive: s.default.string,
    hideArrows: s.default.bool,
    hideSingleArrow: s.default.bool,
    onSelect: s.default.func,
    onClick: s.default.func,
    selected: s.default.oneOfType([s.default.number, s.default.string]),
    translate: s.default.number,
    transition: s.default.number,
    onUpdate: s.default.func,
    menuClass: s.default.string,
    menuStyle: s.default.object,
    wrapperStyle: s.default.object,
    wheel: s.default.bool,
    wrapperClass: s.default.string
  };

  v.defaultProps = l.defaultProps, v.propTypes = w, t.default = v;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(6));

  t.default = r.default;
}]);